export default __webpack_public_path__ + "static/media/7VK61.1d86e531.jpg";